module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/cooking/saucepan-da5ae53c88c7ab621182167b02354c3c.svg";